export default __webpack_public_path__ + "static/media/upload_icon.1d8ab410.svg";